import ko from "knockout";
import $ from "jquery";
import "lib/bootstrap.tooltip";

/*
 * Binding handler for sliding up/down content, based on the value of the passed observable.
 * Slides down the content when the observable is true, and slides it back up when false.
 */

ko.bindingHandlers.slideDown = {
    init: function (element) {
        const $el = $(element);
        $el.addClass("slide-panel");

        $el.hide();
    },
    update: function (element, valueAccessor) {
        const $el = $(element);
        const duration = 200;

        if (ko.unwrap(valueAccessor())) {
            $el.slideDown(duration);
        } else {
            $el.slideUp(duration);
        }
    },
};
